export const UNAUTHORIZED_ERROR = 'Unauthorized error';

// Rejected for a 401 so callers can still dispatch on `response.status` — AppLoading relies on it
// to show "redirecting..." instead of rendering the app (and its error banner) underneath.
export default class ErrorUnauthorized extends Error {
  public response: any;

  public status: number;

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  constructor(response: any) {
    super(UNAUTHORIZED_ERROR);

    this.name = 'ErrorUnauthorized';
    this.response = response;
    this.status = response?.status;
  }
}
